import { render, staticRenderFns } from "./EditDetailsForm.vue?vue&type=template&id=1230e158&"
import script from "./EditDetailsForm.vue?vue&type=script&lang=js&"
export * from "./EditDetailsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports